// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

/**
 * Base URL for every API request. On the web it is the relative '/api' (same origin).
 * The Capacitor shell serves the app from https://localhost, so native builds set
 * VITE_API_BASE_URL to the real API host. Anything that calls the API — the axios
 * clients and the auth store's raw fetches — must build its URL from this (AA13).
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || '/api';
